@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

@delegate:ResourceContentHash(77_439_551)
internal val Res.string.account_actions_title: StringResource by lazy {
      StringResource("string:account_actions_title", "account_actions_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 10, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 41),
      ))
    }

@delegate:ResourceContentHash(-383_504_621)
internal val Res.string.account_active_probes: StringResource by lazy {
      StringResource("string:account_active_probes", "account_active_probes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 52, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 52, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 52, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52, 49),
      ))
    }

@delegate:ResourceContentHash(1_549_267_602)
internal val Res.string.account_alert_both: StringResource by lazy {
      StringResource("string:account_alert_both", "account_alert_both", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 106, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 106, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 106, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102, 54),
      ))
    }

@delegate:ResourceContentHash(-310_637_025)
internal val Res.string.account_alert_email_desc: StringResource by lazy {
      StringResource("string:account_alert_email_desc", "account_alert_email_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 161, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 165, 96),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 161, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 157, 88),
      ))
    }

@delegate:ResourceContentHash(-1_330_317_220)
internal val Res.string.account_alert_email_hint: StringResource by lazy {
      StringResource("string:account_alert_email_hint", "account_alert_email_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 258, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 262, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 258, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 246, 56),
      ))
    }

@delegate:ResourceContentHash(-1_281_271_404)
internal val Res.string.account_alert_email_toggle: StringResource by lazy {
      StringResource("string:account_alert_email_toggle", "account_alert_email_toggle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 323, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 323, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 323, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303, 50),
      ))
    }

@delegate:ResourceContentHash(-566_341_947)
internal val Res.string.account_alert_explanation: StringResource by lazy {
      StringResource("string:account_alert_explanation", "account_alert_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 382, 561),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 382, 533),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 382, 565),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354, 557),
      ))
    }

@delegate:ResourceContentHash(1_425_877_645)
internal val Res.string.account_alert_less_1km: StringResource by lazy {
      StringResource("string:account_alert_less_1km", "account_alert_less_1km", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 944, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 916, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 948, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 912, 50),
      ))
    }

@delegate:ResourceContentHash(89_893_619)
internal val Res.string.account_alert_less_2km: StringResource by lazy {
      StringResource("string:account_alert_less_2km", "account_alert_less_2km", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 995, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 967, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 999, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 963, 50),
      ))
    }

@delegate:ResourceContentHash(1_663_712_059)
internal val Res.string.account_alert_none: StringResource by lazy {
      StringResource("string:account_alert_none", "account_alert_none", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1046, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1018, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1050, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1014, 38),
      ))
    }

@delegate:ResourceContentHash(2_070_801_178)
internal val Res.string.account_alert_not_eligible: StringResource by lazy {
      StringResource("string:account_alert_not_eligible", "account_alert_not_eligible", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1089, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1065, 130),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1093, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1053, 122),
      ))
    }

@delegate:ResourceContentHash(523_120_331)
internal val Res.string.account_alert_radius_label: StringResource by lazy {
      StringResource("string:account_alert_radius_label", "account_alert_radius_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1232, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1196, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1228, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1176, 54),
      ))
    }

@delegate:ResourceContentHash(139_359_393)
internal val Res.string.account_alert_save: StringResource by lazy {
      StringResource("string:account_alert_save", "account_alert_save", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1472, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1448, 66),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1464, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1384, 50),
      ))
    }

@delegate:ResourceContentHash(-1_118_383_513)
internal val Res.string.account_alert_save_error: StringResource by lazy {
      StringResource("string:account_alert_save_error", "account_alert_save_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1295, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1259, 120),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1291, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1231, 100),
      ))
    }

@delegate:ResourceContentHash(464_687_605)
internal val Res.string.account_alert_saved: StringResource by lazy {
      StringResource("string:account_alert_saved", "account_alert_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1412, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1380, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1408, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1332, 51),
      ))
    }

@delegate:ResourceContentHash(1_623_064_386)
internal val Res.string.account_alert_title: StringResource by lazy {
      StringResource("string:account_alert_title", "account_alert_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1527, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1515, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1519, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1435, 35),
      ))
    }

@delegate:ResourceContentHash(1_906_167_906)
internal val Res.string.account_empty_probes: StringResource by lazy {
      StringResource("string:account_empty_probes", "account_empty_probes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1567, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1555, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1559, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1471, 48),
      ))
    }

@delegate:ResourceContentHash(145_222_807)
internal val Res.string.account_historical_impacts: StringResource by lazy {
      StringResource("string:account_historical_impacts", "account_historical_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1636, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1612, 70),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1620, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1520, 70),
      ))
    }

@delegate:ResourceContentHash(-2_091_925_597)
internal val Res.string.account_language_title: StringResource by lazy {
      StringResource("string:account_language_title", "account_language_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1711, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1683, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1695, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1591, 46),
      ))
    }

@delegate:ResourceContentHash(-1_872_712_638)
internal val Res.string.account_logout: StringResource by lazy {
      StringResource("string:account_logout", "account_logout", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1774, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1746, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1754, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1638, 34),
      ))
    }

@delegate:ResourceContentHash(1_701_925_330)
internal val Res.string.account_lps_distance: StringResource by lazy {
      StringResource("string:account_lps_distance", "account_lps_distance", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1817, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1789, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1785, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1673, 44),
      ))
    }

@delegate:ResourceContentHash(600_645_982)
internal val Res.string.account_lps_projects_none: StringResource by lazy {
      StringResource("string:account_lps_projects_none", "account_lps_projects_none", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1858, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1834, 89),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1826, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1718, 77),
      ))
    }

@delegate:ResourceContentHash(-616_827_986)
internal val Res.string.account_lps_projects_title: StringResource by lazy {
      StringResource("string:account_lps_projects_title", "account_lps_projects_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1944, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1924, 78),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1916, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1796, 74),
      ))
    }

@delegate:ResourceContentHash(-497_747_668)
internal val Res.string.account_new_probe_subtitle: StringResource by lazy {
      StringResource("string:account_new_probe_subtitle", "account_new_probe_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2023, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2003, 126),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 1991, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1871, 114),
      ))
    }

@delegate:ResourceContentHash(-241_516_257)
internal val Res.string.account_new_probe_title: StringResource by lazy {
      StringResource("string:account_new_probe_title", "account_new_probe_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2134, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2130, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2106, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1986, 43),
      ))
    }

@delegate:ResourceContentHash(1_201_243_894)
internal val Res.string.account_notif_high_intensity: StringResource by lazy {
      StringResource("string:account_notif_high_intensity", "account_notif_high_intensity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2182, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2182, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2154, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2030, 68),
      ))
    }

@delegate:ResourceContentHash(1_003_868_642)
internal val Res.string.account_notif_new_documents: StringResource by lazy {
      StringResource("string:account_notif_new_documents", "account_notif_new_documents", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2251, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2255, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2227, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2099, 55),
      ))
    }

@delegate:ResourceContentHash(1_617_962_996)
internal val Res.string.account_notif_renewal: StringResource by lazy {
      StringResource("string:account_notif_renewal", "account_notif_renewal", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2311, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2315, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2287, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2155, 57),
      ))
    }

@delegate:ResourceContentHash(2_133_096_144)
internal val Res.string.account_notif_weekly_report: StringResource by lazy {
      StringResource("string:account_notif_weekly_report", "account_notif_weekly_report", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2377, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2381, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2353, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2213, 55),
      ))
    }

@delegate:ResourceContentHash(-598_740_215)
internal val Res.string.account_password_confirm: StringResource by lazy {
      StringResource("string:account_password_confirm", "account_password_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2433, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2445, 76),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2413, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2269, 60),
      ))
    }

@delegate:ResourceContentHash(-1_339_433_606)
internal val Res.string.account_password_error_empty: StringResource by lazy {
      StringResource("string:account_password_error_empty", "account_password_error_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2502, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2522, 80),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2474, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2330, 72),
      ))
    }

@delegate:ResourceContentHash(-421_053_996)
internal val Res.string.account_password_error_generic: StringResource by lazy {
      StringResource("string:account_password_error_generic", "account_password_error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2575, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2603, 98),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2543, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2403, 86),
      ))
    }

@delegate:ResourceContentHash(2_031_143_898)
internal val Res.string.account_password_error_mismatch: StringResource by lazy {
      StringResource("string:account_password_error_mismatch", "account_password_error_mismatch", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2670, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2702, 91),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2626, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2490, 71),
      ))
    }

@delegate:ResourceContentHash(36_781_003)
internal val Res.string.account_password_error_wrong: StringResource by lazy {
      StringResource("string:account_password_error_wrong", "account_password_error_wrong", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2750, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2794, 76),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2698, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2562, 76),
      ))
    }

@delegate:ResourceContentHash(-1_294_879_384)
internal val Res.string.account_password_new: StringResource by lazy {
      StringResource("string:account_password_new", "account_password_new", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2835, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2871, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2775, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2639, 44),
      ))
    }

@delegate:ResourceContentHash(-354_685_412)
internal val Res.string.account_password_old: StringResource by lazy {
      StringResource("string:account_password_old", "account_password_old", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2888, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2928, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2820, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2684, 52),
      ))
    }

@delegate:ResourceContentHash(-1_536_892_853)
internal val Res.string.account_password_success: StringResource by lazy {
      StringResource("string:account_password_success", "account_password_success", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2941, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2985, 80),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2865, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2737, 72),
      ))
    }

@delegate:ResourceContentHash(1_832_219_938)
internal val Res.string.account_probe_created_label: StringResource by lazy {
      StringResource("string:account_probe_created_label", "account_probe_created_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3022, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3066, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2934, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2810, 51),
      ))
    }

@delegate:ResourceContentHash(446_998_635)
internal val Res.string.account_profile_title: StringResource by lazy {
      StringResource("string:account_profile_title", "account_profile_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3070, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3118, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 2982, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2862, 41),
      ))
    }

@delegate:ResourceContentHash(-176_923_691)
internal val Res.string.account_referral_coming_soon: StringResource by lazy {
      StringResource("string:account_referral_coming_soon", "account_referral_coming_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3316, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3392, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3232, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3116, 52),
      ))
    }

@delegate:ResourceContentHash(-1_674_487_052)
internal val Res.string.account_referral_coming_soon_detail: StringResource by lazy {
      StringResource("string:account_referral_coming_soon_detail", "account_referral_coming_soon_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3108, 207),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3156, 235),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3020, 211),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2904, 211),
      ))
    }

@delegate:ResourceContentHash(-416_140_182)
internal val Res.string.account_referral_title: StringResource by lazy {
      StringResource("string:account_referral_title", "account_referral_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3373, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3457, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3281, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3169, 54),
      ))
    }

@delegate:ResourceContentHash(1_688_682_198)
internal val Res.string.account_rename_failed: StringResource by lazy {
      StringResource("string:account_rename_failed", "account_rename_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3432, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3520, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3344, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3224, 49),
      ))
    }

@delegate:ResourceContentHash(1_839_974_596)
internal val Res.string.account_security_change_password: StringResource by lazy {
      StringResource("string:account_security_change_password", "account_security_change_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3486, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3578, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3398, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3274, 60),
      ))
    }

@delegate:ResourceContentHash(965_342_937)
internal val Res.string.account_security_title: StringResource by lazy {
      StringResource("string:account_security_title", "account_security_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3555, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3651, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3459, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3335, 42),
      ))
    }

@delegate:ResourceContentHash(-313_753_192)
internal val Res.string.account_status_active: StringResource by lazy {
      StringResource("string:account_status_active", "account_status_active", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3598, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3698, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3506, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3378, 45),
      ))
    }

@delegate:ResourceContentHash(2_126_446_768)
internal val Res.string.account_subscription_annual: StringResource by lazy {
      StringResource("string:account_subscription_annual", "account_subscription_annual", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3644, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3740, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3548, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3424, 43),
      ))
    }

@delegate:ResourceContentHash(1_252_214_989)
internal val Res.string.account_subscription_invoices: StringResource by lazy {
      StringResource("string:account_subscription_invoices", "account_subscription_invoices", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3688, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3784, 53),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3592, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3468, 53),
      ))
    }

@delegate:ResourceContentHash(1_864_151_744)
internal val Res.string.account_subscription_manage: StringResource by lazy {
      StringResource("string:account_subscription_manage", "account_subscription_manage", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3742, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3838, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3650, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3522, 67),
      ))
    }

@delegate:ResourceContentHash(1_908_547_818)
internal val Res.string.account_subscription_mode_label: StringResource by lazy {
      StringResource("string:account_subscription_mode_label", "account_subscription_mode_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3814, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3902, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3722, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3590, 51),
      ))
    }

@delegate:ResourceContentHash(-1_631_091_948)
internal val Res.string.account_subscription_network_label: StringResource by lazy {
      StringResource("string:account_subscription_network_label", "account_subscription_network_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3870, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3958, 70),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3778, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3642, 66),
      ))
    }

@delegate:ResourceContentHash(1_550_773_338)
internal val Res.string.account_subscription_plan_label: StringResource by lazy {
      StringResource("string:account_subscription_plan_label", "account_subscription_plan_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3937, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4029, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3845, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3709, 55),
      ))
    }

@delegate:ResourceContentHash(1_056_580_412)
internal val Res.string.account_subscription_renewal_label: StringResource by lazy {
      StringResource("string:account_subscription_renewal_label", "account_subscription_renewal_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3993, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4093, 62),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3901, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3765, 54),
      ))
    }

@delegate:ResourceContentHash(-1_015_121_091)
internal val Res.string.account_subscription_title: StringResource by lazy {
      StringResource("string:account_subscription_title", "account_subscription_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4052, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4156, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 3960, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3820, 50),
      ))
    }

@delegate:ResourceContentHash(-1_651_331_058)
internal val Res.string.account_support_contact: StringResource by lazy {
      StringResource("string:account_support_contact", "account_support_contact", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4103, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4207, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4011, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3871, 51),
      ))
    }

@delegate:ResourceContentHash(1_171_225_344)
internal val Res.string.account_support_title: StringResource by lazy {
      StringResource("string:account_support_title", "account_support_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4159, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4267, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4067, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3923, 41),
      ))
    }

@delegate:ResourceContentHash(1_272_980_374)
internal val Res.string.account_total_coverage: StringResource by lazy {
      StringResource("string:account_total_coverage", "account_total_coverage", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4201, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4313, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4109, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3965, 54),
      ))
    }

@delegate:ResourceContentHash(199_519_352)
internal val Res.string.action_share: StringResource by lazy {
      StringResource("string:action_share", "action_share", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4260, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4372, 32),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4164, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4020, 28),
      ))
    }

@delegate:ResourceContentHash(1_314_784_965)
internal val Res.string.admin_map_group_mode_cancel: StringResource by lazy {
      StringResource("string:admin_map_group_mode_cancel", "admin_map_group_mode_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4293, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4405, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4201, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4049, 43),
      ))
    }

@delegate:ResourceContentHash(-1_976_620_669)
internal val Res.string.admin_map_group_mode_commit: StringResource by lazy {
      StringResource("string:admin_map_group_mode_commit", "admin_map_group_mode_commit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4341, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4453, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4249, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4093, 43),
      ))
    }

@delegate:ResourceContentHash(1_364_118_090)
internal val Res.string.admin_map_group_mode_start: StringResource by lazy {
      StringResource("string:admin_map_group_mode_start", "admin_map_group_mode_start", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4389, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4501, 70),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4297, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4137, 62),
      ))
    }

@delegate:ResourceContentHash(1_468_643_527)
internal val Res.string.admin_map_group_mode_stop: StringResource by lazy {
      StringResource("string:admin_map_group_mode_stop", "admin_map_group_mode_stop", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4456, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4572, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4372, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4200, 61),
      ))
    }

@delegate:ResourceContentHash(242_899_156)
internal val Res.string.alert_banner_approaching_threat: StringResource by lazy {
      StringResource("string:alert_banner_approaching_threat", "alert_banner_approaching_threat", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4522, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4638, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4442, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4262, 63),
      ))
    }

@delegate:ResourceContentHash(-1_047_940_208)
internal val Res.string.alert_banner_average: StringResource by lazy {
      StringResource("string:alert_banner_average", "alert_banner_average", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4594, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4702, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4514, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4326, 32),
      ))
    }

@delegate:ResourceContentHash(-812_131_504)
internal val Res.string.alert_banner_closest: StringResource by lazy {
      StringResource("string:alert_banner_closest", "alert_banner_closest", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4631, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4739, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4551, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4359, 48),
      ))
    }

@delegate:ResourceContentHash(839_677_819)
internal val Res.string.alert_banner_maximum: StringResource by lazy {
      StringResource("string:alert_banner_maximum", "alert_banner_maximum", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4688, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4788, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4612, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4408, 32),
      ))
    }

@delegate:ResourceContentHash(237_228_219)
internal val Res.string.alert_banner_minimum: StringResource by lazy {
      StringResource("string:alert_banner_minimum", "alert_banner_minimum", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4721, 32),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4825, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4645, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4441, 32),
      ))
    }

@delegate:ResourceContentHash(-121_430_198)
internal val Res.string.alert_banner_strongest: StringResource by lazy {
      StringResource("string:alert_banner_strongest", "alert_banner_strongest", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4754, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4862, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4678, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4474, 54),
      ))
    }

@delegate:ResourceContentHash(1_033_905_038)
internal val Res.string.app_login_title: StringResource by lazy {
      StringResource("string:app_login_title", "app_login_title", setOf(
        ResourceItem(setOf(), "${MD}values/login.commonMain.cvr", 10, 39),
      ))
    }

@delegate:ResourceContentHash(-615_971_750)
internal val Res.string.app_main_title: StringResource by lazy {
      StringResource("string:app_main_title", "app_main_title", setOf(
        ResourceItem(setOf(), "${MD}values/login.commonMain.cvr", 50, 54),
      ))
    }

@delegate:ResourceContentHash(2_025_026_432)
internal val Res.string.app_title: StringResource by lazy {
      StringResource("string:app_title", "app_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4813, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4909, 33),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4737, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4529, 33),
      ))
    }

@delegate:ResourceContentHash(-641_435_232)
internal val Res.string.aqi_index: StringResource by lazy {
      StringResource("string:aqi_index", "aqi_index", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4847, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4943, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4771, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4563, 33),
      ))
    }

@delegate:ResourceContentHash(637_129_617)
internal val Res.string.auth_error_email_already_used: StringResource by lazy {
      StringResource("string:auth_error_email_already_used", "auth_error_email_already_used", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4889, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4985, 149),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4809, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4597, 137),
      ))
    }

@delegate:ResourceContentHash(-2_077_350_422)
internal val Res.string.auth_error_generic: StringResource by lazy {
      StringResource("string:auth_error_generic", "auth_error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5035, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5135, 126),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4931, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4735, 114),
      ))
    }

@delegate:ResourceContentHash(596_666_197)
internal val Res.string.auth_error_invalid_body: StringResource by lazy {
      StringResource("string:auth_error_invalid_body", "auth_error_invalid_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5158, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5262, 163),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5038, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4850, 147),
      ))
    }

@delegate:ResourceContentHash(-957_215_917)
internal val Res.string.auth_error_invalid_credentials: StringResource by lazy {
      StringResource("string:auth_error_invalid_credentials", "auth_error_invalid_credentials", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5318, 158),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5426, 150),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5198, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4998, 114),
      ))
    }

@delegate:ResourceContentHash(706_469_508)
internal val Res.string.auth_error_invalid_email: StringResource by lazy {
      StringResource("string:auth_error_invalid_email", "auth_error_invalid_email", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5477, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5577, 116),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5329, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5113, 100),
      ))
    }

@delegate:ResourceContentHash(-1_989_595_225)
internal val Res.string.auth_error_invalid_reset_code: StringResource by lazy {
      StringResource("string:auth_error_invalid_reset_code", "auth_error_invalid_reset_code", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5602, 233),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5694, 221),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5434, 209),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5214, 177),
      ))
    }

@delegate:ResourceContentHash(-644_756_123)
internal val Res.string.auth_error_password_too_short: StringResource by lazy {
      StringResource("string:auth_error_password_too_short", "auth_error_password_too_short", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5836, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5916, 113),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5644, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5392, 105),
      ))
    }

@delegate:ResourceContentHash(-748_527_310)
internal val Res.string.auth_error_server: StringResource by lazy {
      StringResource("string:auth_error_server", "auth_error_server", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 5942, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6030, 153),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5746, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5498, 129),
      ))
    }

@delegate:ResourceContentHash(1_314_784_965)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6096, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6184, 26),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5884, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5628, 22),
      ))
    }

@delegate:ResourceContentHash(1_331_291_998)
internal val Res.string.card_show_amount: StringResource by lazy {
      StringResource("string:card_show_amount", "card_show_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6123, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6211, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5911, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5651, 32),
      ))
    }

@delegate:ResourceContentHash(299_702_325)
internal val Res.string.card_show_card_name: StringResource by lazy {
      StringResource("string:card_show_card_name", "card_show_card_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6160, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6248, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 5952, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5684, 39),
      ))
    }

@delegate:ResourceContentHash(-1_926_982_592)
internal val Res.string.card_show_max: StringResource by lazy {
      StringResource("string:card_show_max", "card_show_max", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6212, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6300, 25),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6000, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5724, 25),
      ))
    }

@delegate:ResourceContentHash(-1_888_718_080)
internal val Res.string.card_show_min: StringResource by lazy {
      StringResource("string:card_show_min", "card_show_min", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6238, 25),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6326, 25),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6026, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5750, 25),
      ))
    }

@delegate:ResourceContentHash(14_890_544)
internal val Res.string.cert_add_observations: StringResource by lazy {
      StringResource("string:cert_add_observations", "cert_add_observations", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6264, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6352, 65),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6052, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5776, 57),
      ))
    }

@delegate:ResourceContentHash(410_634_070)
internal val Res.string.cert_current_case: StringResource by lazy {
      StringResource("string:cert_current_case", "cert_current_case", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6384, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6476, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6176, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5896, 49),
      ))
    }

@delegate:ResourceContentHash(2_123_084_591)
internal val Res.string.cert_current_case_pct: StringResource by lazy {
      StringResource("string:cert_current_case_pct", "cert_current_case_pct", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6326, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6418, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6118, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5834, 61),
      ))
    }

@delegate:ResourceContentHash(-1_578_087_256)
internal val Res.string.cert_electromagnetic_effects: StringResource by lazy {
      StringResource("string:cert_electromagnetic_effects", "cert_electromagnetic_effects", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6430, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6522, 84),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6222, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5946, 76),
      ))
    }

@delegate:ResourceContentHash(263_374_327)
internal val Res.string.cert_foudr_cloud_ground: StringResource by lazy {
      StringResource("string:cert_foudr_cloud_ground", "cert_foudr_cloud_ground", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6511, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6607, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6303, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6023, 59),
      ))
    }

@delegate:ResourceContentHash(28_024_501)
internal val Res.string.cert_foudr_date_time: StringResource by lazy {
      StringResource("string:cert_foudr_date_time", "cert_foudr_date_time", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6567, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6663, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6359, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6083, 44),
      ))
    }

@delegate:ResourceContentHash(48_701_491)
internal val Res.string.cert_foudr_distance: StringResource by lazy {
      StringResource("string:cert_foudr_distance", "cert_foudr_distance", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6616, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6712, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6404, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6128, 39),
      ))
    }

@delegate:ResourceContentHash(-1_406_951_624)
internal val Res.string.cert_foudr_intensity: StringResource by lazy {
      StringResource("string:cert_foudr_intensity", "cert_foudr_intensity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6656, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6752, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6448, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6168, 40),
      ))
    }

@delegate:ResourceContentHash(210_052_832)
internal val Res.string.cert_foudr_network: StringResource by lazy {
      StringResource("string:cert_foudr_network", "cert_foudr_network", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6701, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6797, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6493, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6209, 38),
      ))
    }

@delegate:ResourceContentHash(-1_851_245_992)
internal val Res.string.cert_foudr_screen_title: StringResource by lazy {
      StringResource("string:cert_foudr_screen_title", "cert_foudr_screen_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6732, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6836, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6528, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6248, 71),
      ))
    }

@delegate:ResourceContentHash(2_130_003_033)
internal val Res.string.cert_foudr_studied_site: StringResource by lazy {
      StringResource("string:cert_foudr_studied_site", "cert_foudr_studied_site", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6804, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6904, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6600, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6320, 47),
      ))
    }

@delegate:ResourceContentHash(-196_119_052)
internal val Res.string.cert_foudr_subtitle: StringResource by lazy {
      StringResource("string:cert_foudr_subtitle", "cert_foudr_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6856, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6956, 83),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6652, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6368, 79),
      ))
    }

@delegate:ResourceContentHash(-1_923_845_988)
internal val Res.string.cert_foudr_title: StringResource by lazy {
      StringResource("string:cert_foudr_title", "cert_foudr_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 6944, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7040, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6740, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6448, 76),
      ))
    }

@delegate:ResourceContentHash(-169_229_766)
internal val Res.string.cert_foudr_type_label: StringResource by lazy {
      StringResource("string:cert_foudr_type_label", "cert_foudr_type_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7021, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7113, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6817, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6525, 37),
      ))
    }

@delegate:ResourceContentHash(-757_502_034)
internal val Res.string.cert_incidence_direct_indirect: StringResource by lazy {
      StringResource("string:cert_incidence_direct_indirect", "cert_incidence_direct_indirect", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 7059, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7151, 94),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 6855, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6563, 94),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("account_actions_title", Res.string.account_actions_title)
  map.put("account_active_probes", Res.string.account_active_probes)
  map.put("account_alert_both", Res.string.account_alert_both)
  map.put("account_alert_email_desc", Res.string.account_alert_email_desc)
  map.put("account_alert_email_hint", Res.string.account_alert_email_hint)
  map.put("account_alert_email_toggle", Res.string.account_alert_email_toggle)
  map.put("account_alert_explanation", Res.string.account_alert_explanation)
  map.put("account_alert_less_1km", Res.string.account_alert_less_1km)
  map.put("account_alert_less_2km", Res.string.account_alert_less_2km)
  map.put("account_alert_none", Res.string.account_alert_none)
  map.put("account_alert_not_eligible", Res.string.account_alert_not_eligible)
  map.put("account_alert_radius_label", Res.string.account_alert_radius_label)
  map.put("account_alert_save", Res.string.account_alert_save)
  map.put("account_alert_save_error", Res.string.account_alert_save_error)
  map.put("account_alert_saved", Res.string.account_alert_saved)
  map.put("account_alert_title", Res.string.account_alert_title)
  map.put("account_empty_probes", Res.string.account_empty_probes)
  map.put("account_historical_impacts", Res.string.account_historical_impacts)
  map.put("account_language_title", Res.string.account_language_title)
  map.put("account_logout", Res.string.account_logout)
  map.put("account_lps_distance", Res.string.account_lps_distance)
  map.put("account_lps_projects_none", Res.string.account_lps_projects_none)
  map.put("account_lps_projects_title", Res.string.account_lps_projects_title)
  map.put("account_new_probe_subtitle", Res.string.account_new_probe_subtitle)
  map.put("account_new_probe_title", Res.string.account_new_probe_title)
  map.put("account_notif_high_intensity", Res.string.account_notif_high_intensity)
  map.put("account_notif_new_documents", Res.string.account_notif_new_documents)
  map.put("account_notif_renewal", Res.string.account_notif_renewal)
  map.put("account_notif_weekly_report", Res.string.account_notif_weekly_report)
  map.put("account_password_confirm", Res.string.account_password_confirm)
  map.put("account_password_error_empty", Res.string.account_password_error_empty)
  map.put("account_password_error_generic", Res.string.account_password_error_generic)
  map.put("account_password_error_mismatch", Res.string.account_password_error_mismatch)
  map.put("account_password_error_wrong", Res.string.account_password_error_wrong)
  map.put("account_password_new", Res.string.account_password_new)
  map.put("account_password_old", Res.string.account_password_old)
  map.put("account_password_success", Res.string.account_password_success)
  map.put("account_probe_created_label", Res.string.account_probe_created_label)
  map.put("account_profile_title", Res.string.account_profile_title)
  map.put("account_referral_coming_soon", Res.string.account_referral_coming_soon)
  map.put("account_referral_coming_soon_detail", Res.string.account_referral_coming_soon_detail)
  map.put("account_referral_title", Res.string.account_referral_title)
  map.put("account_rename_failed", Res.string.account_rename_failed)
  map.put("account_security_change_password", Res.string.account_security_change_password)
  map.put("account_security_title", Res.string.account_security_title)
  map.put("account_status_active", Res.string.account_status_active)
  map.put("account_subscription_annual", Res.string.account_subscription_annual)
  map.put("account_subscription_invoices", Res.string.account_subscription_invoices)
  map.put("account_subscription_manage", Res.string.account_subscription_manage)
  map.put("account_subscription_mode_label", Res.string.account_subscription_mode_label)
  map.put("account_subscription_network_label", Res.string.account_subscription_network_label)
  map.put("account_subscription_plan_label", Res.string.account_subscription_plan_label)
  map.put("account_subscription_renewal_label", Res.string.account_subscription_renewal_label)
  map.put("account_subscription_title", Res.string.account_subscription_title)
  map.put("account_support_contact", Res.string.account_support_contact)
  map.put("account_support_title", Res.string.account_support_title)
  map.put("account_total_coverage", Res.string.account_total_coverage)
  map.put("action_share", Res.string.action_share)
  map.put("admin_map_group_mode_cancel", Res.string.admin_map_group_mode_cancel)
  map.put("admin_map_group_mode_commit", Res.string.admin_map_group_mode_commit)
  map.put("admin_map_group_mode_start", Res.string.admin_map_group_mode_start)
  map.put("admin_map_group_mode_stop", Res.string.admin_map_group_mode_stop)
  map.put("alert_banner_approaching_threat", Res.string.alert_banner_approaching_threat)
  map.put("alert_banner_average", Res.string.alert_banner_average)
  map.put("alert_banner_closest", Res.string.alert_banner_closest)
  map.put("alert_banner_maximum", Res.string.alert_banner_maximum)
  map.put("alert_banner_minimum", Res.string.alert_banner_minimum)
  map.put("alert_banner_strongest", Res.string.alert_banner_strongest)
  map.put("app_login_title", Res.string.app_login_title)
  map.put("app_main_title", Res.string.app_main_title)
  map.put("app_title", Res.string.app_title)
  map.put("aqi_index", Res.string.aqi_index)
  map.put("auth_error_email_already_used", Res.string.auth_error_email_already_used)
  map.put("auth_error_generic", Res.string.auth_error_generic)
  map.put("auth_error_invalid_body", Res.string.auth_error_invalid_body)
  map.put("auth_error_invalid_credentials", Res.string.auth_error_invalid_credentials)
  map.put("auth_error_invalid_email", Res.string.auth_error_invalid_email)
  map.put("auth_error_invalid_reset_code", Res.string.auth_error_invalid_reset_code)
  map.put("auth_error_password_too_short", Res.string.auth_error_password_too_short)
  map.put("auth_error_server", Res.string.auth_error_server)
  map.put("cancel", Res.string.cancel)
  map.put("card_show_amount", Res.string.card_show_amount)
  map.put("card_show_card_name", Res.string.card_show_card_name)
  map.put("card_show_max", Res.string.card_show_max)
  map.put("card_show_min", Res.string.card_show_min)
  map.put("cert_add_observations", Res.string.cert_add_observations)
  map.put("cert_current_case", Res.string.cert_current_case)
  map.put("cert_current_case_pct", Res.string.cert_current_case_pct)
  map.put("cert_electromagnetic_effects", Res.string.cert_electromagnetic_effects)
  map.put("cert_foudr_cloud_ground", Res.string.cert_foudr_cloud_ground)
  map.put("cert_foudr_date_time", Res.string.cert_foudr_date_time)
  map.put("cert_foudr_distance", Res.string.cert_foudr_distance)
  map.put("cert_foudr_intensity", Res.string.cert_foudr_intensity)
  map.put("cert_foudr_network", Res.string.cert_foudr_network)
  map.put("cert_foudr_screen_title", Res.string.cert_foudr_screen_title)
  map.put("cert_foudr_studied_site", Res.string.cert_foudr_studied_site)
  map.put("cert_foudr_subtitle", Res.string.cert_foudr_subtitle)
  map.put("cert_foudr_title", Res.string.cert_foudr_title)
  map.put("cert_foudr_type_label", Res.string.cert_foudr_type_label)
  map.put("cert_incidence_direct_indirect", Res.string.cert_incidence_direct_indirect)
}
